import { AuthAPI } from '@api';

const signOut = async () => AuthAPI.signOut()
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { signOut };
